// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3QseG","upload":"Small_upload__2EN1o","imageWrap":"Small_imageWrap__2EW5c","removeBtn":"Small_removeBtn__nFFLF"};